import { render, staticRenderFns } from "./payment-type-modal.vue?vue&type=template&id=48895e34&scoped=true"
import script from "./payment-type-modal.vue?vue&type=script&lang=js"
export * from "./payment-type-modal.vue?vue&type=script&lang=js"
import style0 from "./payment-type-modal.vue?vue&type=style&index=0&id=48895e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48895e34",
  null
  
)

export default component.exports